// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1WHdS","validationTips":"StatementDescriptor_validationTips__3t16o"};